import React, { Component } from 'react';
import wx from 'weixin-js-sdk';
import PropTypes from 'prop-types';
import { forward, getWxShareInfo, spread } from '../../service/chat-service';
// import {Toast} from "antd-mobile";
import tools from '../../utils/tools';

const propTypes = {
  productName: PropTypes.string,
};
const defaultProps = {
  productName: '',
};

class ActivityShare extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // forwardId: null,
    };
  }

  async componentDidMount() {
    // 活动分享
    await this.initWxConfig();
    await this.setSpread();
  }

  /**
   * 活动start
   * */

  // 微信分享必要配置。参数必须由后端生成
  initWxConfig = async () => {
    const wxShareUrl = window.location.href.split('#')[0];
    const data = await getWxShareInfo(wxShareUrl);

    try {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appid, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      this.handleWxShare();
    } catch (e) {
      // console.log(e);
    }
  }

  // 点击链接浏览记录
  setSpread = async () => {
    const productId = tools.getQueryString('productId');
    const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');
    const forwardOpenId = tools.getQueryString('forwardOpenId');
    try {
      if (window.location.href.indexOf('forwardOpenId') !== -1) {
        spread(snsapiBaseOpenId, productId, forwardOpenId, window.location.href).then(() => {
          // console.log('执行的回调函数===>', res);
        });
      }
    } catch (e) {
      // console.log(e);
    }
  }

  // 替换url参数
  changeURLArg = (url, arg, argVal) => {
    const pattern = `${arg}=([^&]*)`;
    const replaceText = `${arg}=${argVal}`;
    if (url.match(pattern)) {
      let tmp = `/(${arg}=)([^&]*)/gi`;
      // eslint-disable-next-line no-eval
      tmp = url.replace(eval(tmp), replaceText);
      return tmp;
    }
    if (url.match('[?]')) {
      return `${url}&${replaceText}`;
    }
    return `${url}?${replaceText}`;
  }

  // 整理分享链接
  handleShareUrl = () => {
    const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');
    const href = window.location.href.indexOf('sourceUrl') !== -1
      ? window.location.href.split('&sourceUrl=')[1]
      : window.location.href;
    const url = this.changeURLArg(href.replace(/rewardRule/, 'productDetail'), 'forwardOpenId', snsapiBaseOpenId).split(
      '&',
    );
    const shareUrl = url.filter((item) => item.indexOf('code') === -1 && item.indexOf('state') === -1);
    return shareUrl.join('&');
  }

  // 调取微信分享SDk
  handleWxShare = () => {
    const { productName } = this.props;
    const fixedTitle = '好品 好事 好商机，助力传播领福利';
    const productNameFromUrl = tools.getQueryString('productName');
    // const wxImgFromUrl = tools.getQueryString('productImg')
    const productId = tools.getQueryString('productId');
    const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');
    const wxTitle = productNameFromUrl !== 'null' ? productNameFromUrl : productName || fixedTitle;
    // const wxImg = wxImgFromUrl !== "null" ? wxImgFromUrl : productImg.imgUrl
    // const wxImg = !!productImg ? productImg.imgUrl : wxImgFromUrl

    wx.ready(() => {
      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: wxTitle, // 分享标题
        desc: '转发此链接有奖！真微信红包，一键提现秒到账。好品多分享，一起助力吧！', // 分享描述
        link: this.handleShareUrl(), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success() {
          // 用户确认分享后执行的回调函数
          forward(snsapiBaseOpenId, productId, window.location.href).then(() => {
            // console.log(res);
          });
        },
        cancel() {
          // 用户取消分享后执行的回调函数
          // console.log(e);
        },
      });

      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: wxTitle, // 分享标题
        link: this.handleShareUrl(), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        desc: '转发此链接有奖！真微信红包，一键提现秒到账。好品多分享，一起助力吧！',
        success() {
          // 用户确认分享后执行的回调函数
          forward(snsapiBaseOpenId, productId, window.location.href).then(() => {
            // console.log(res);
          });
        },
        cancel() {
          // 用户取消分享后执行的回调函数
        },
      });
    });

    wx.error(() => {
      // console.log('errMsg====>>>', res.errMsg);
    });
  }

  /**
   * 活动end
   * */

  render() {
    return <div />;
  }
}

ActivityShare.propTypes = propTypes;
ActivityShare.defaultProps = defaultProps;

export default ActivityShare;
